import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import { captureException } from "@sentry/vue";
export default {
  name: "AppHeader",
  data: function data() {
    return {
      navigationDrawerOpen: false
    };
  },
  methods: {
    logout: function logout() {
      var _this = this;
      this.$http.post('signOut').then(function () {
        _this.$store.dispatch('authLogout').then(function () {
          _this.$router.push({
            path: '/login'
          });
        }).catch(function (error) {
          return captureException(error);
        });
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;
    if (this.$store.getters.isAdviserSignedIn) {
      this.$store.dispatch('getSchool').then(function (response) {
        if (!response.data.status) {
          console.log(Error[response.data.errorCode]);
        }
      }).catch(function (error) {
        captureException(error);
        _this2.logout();
      });
    }
  },
  computed: {
    isAdviserSignedIn: function isAdviserSignedIn() {
      return this.$store.getters.isAdviserSignedIn;
    },
    isAdviserActive: function isAdviserActive() {
      return this.$store.getters.isAdviserActive;
    },
    isSchoolInfoLoaded: function isSchoolInfoLoaded() {
      return this.$store.getters.isSchoolInfoLoaded;
    }
  }
};